export const formatFileSize = (bytes, decimalPoint = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1000;
    const dm = decimalPoint < 0 ? 0 : decimalPoint;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

const SAMPLE_ROW_COUNT = 4;

// Parses an uploaded csv/xls(x) file and returns { headers, totalRows, sampleRows, size (bytes) }.
export const extractFileMeta = async (currentFile) => {
    const file = currentFile.file;
    const ext = currentFile.extension;
    const size = file?.size;
    if (ext === 'csv') {
        const Papa = await import("papaparse");
        return new Promise((resolve, reject) => {
            Papa.parse(file, { header: true, skipEmptyLines: true,
            complete: (results) => {
                const sampleRows = results.data.slice(0, SAMPLE_ROW_COUNT).map(row => results.meta.fields.map(field => row[field]));
                resolve({ headers: results.meta.fields, totalRows: results.data.length, sampleRows, size });
            },
            error: (err) => reject(err),
            });
        });
    } else if (ext === 'xls' || ext === 'xlsx') {
        try {
            const XLSX = await import("xlsx");
            const data = await file.arrayBuffer();
            const workbook = XLSX.read(data, { type: "array" });
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });
            return {
                headers: rows[0] || [],
                totalRows: Math.max(rows.length - 1, 0),
                sampleRows: rows.slice(1, SAMPLE_ROW_COUNT + 1),
                size,
            };
        } catch (err) {
            throw new Error("Error reading Excel file.", err);
        }
    } else {
        throw new Error("Unsupported file format. Please upload a .csv or Excel file.");
    }
};
